<template>
  <b-card>
    <b-row class="position-relative">
      <b-col md="12">
        <div>
          <div class="d-flex align-items-center justify-content-lg-start">
            <Button
              v-if="showBackButton && actionType === 'save' || 'add'"
              :label="$t('List page')"
              size="md"
              icon="ArrowLeftIcon"
              show-icon
              class="mb-1"
              @click="backNavigationAction"
            />
          </div>
          <validation-observer ref="glPostingRules">
            <div class="d-flex mb-2 align-items-center justify-content-between">
              <h5> {{ $t('Account to Debit') }} </h5>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="ml-4"
                @click="repeatAccountToDebit"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span> {{ $t('Add New') }} </span>
              </b-button>
            </div>

            <b-row
              v-for="(item, index) in accountToDebitFormData"
              :id="item.id"
              :key="item.id"
              ref="accounDebitRef"
            >
              <b-col md="3">
                <SelectField
                  id="gl-to-debit"
                  v-model="item.glToDebit"
                  :label="$t('GL to Debit')"
                  :placeholder="$t('Select')"
                  :options="glAccountOptions"
                  :reduce="option => option"
                  rules="required"
                  :error-name="$t('Gl to Debit')"
                  item="label"
                  :loading="isLoadingGlAccount"
                  @input="setGLToDebitAmount(item.glToDebit, index)"
                />
              </b-col>

              <b-col md="3">
                <InputField
                  id="account-number"
                  v-model="item.accountNumber"
                  :label="$t('Account Number')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="2">
                <SelectField
                  id="entry-code-debit"
                  v-model="item.entryCode"
                  :reduce="option => option"
                  :label="$t('Sort Code')"
                  :placeholder="$t('Select')"
                  :options="debitEntryCodeOptions"
                  :error-name="$t('Sort Code')"
                  rules="required"
                  item="label"
                />
                <h6
                  class="cursor-pointer text-secondary entry-code"
                  @click="showModal('modal-primary')"
                >
                  {{ $t('Sort code meaning') }}
                  <feather-icon
                    v-b-tooltip.hover.bottom="$t('Get Information on Sort Code meaning')"
                    icon="InfoIcon"
                    class="mr-25 cursor-pointer text-danger"
                  />
                </h6>
              </b-col>
              <b-col md="3">
                <SelectField
                  id="gl-to-debit"
                  v-model="item.branchCode"
                  :reduce="option => option.value"
                  :label="$t('Branch')"
                  :placeholder="$t('Select')"
                  :options="branchOptions"
                  rules="required"
                  :error-name="$t('Branch to Debit')"
                  item="label"
                  :loading="isLoadingBranches"
                />
              </b-col>

              <b-col md="3">
                <InputNumberField
                  id="amount"
                  v-model="item.amount"
                  :label="$t('Amount')"
                  placeholder=""
                  :error-name="$t('Amount')"
                  rules="required|positive"
                />
              </b-col>
              <b-col md="3">
                <InputField
                  id="instrument-no"
                  v-model="item.instrumentNumber"
                  :label="$t('Instrument Number')"
                  placeholder=""
                  type="text"
                  rules="required"
                  :error-name="$t('Instrument Number')"
                />
              </b-col>

              <b-col md="5">
                <InputField
                  id="narration"
                  v-model="item.narration"
                  :label="$t('Narration')"
                  placeholder=""
                  type="text"
                  rules="required"
                  error-name="narration"
                />
              </b-col>

              <b-col
                md="1"
                class="mt-0"
              >
                <!-- Remove Button -->
                <feather-icon
                  v-b-tooltip.hover.bottom="$t('Remove')"
                  icon="XIcon"
                  class="mr-25 cursor-pointer text-danger"
                  @click="removeAccountToDebitItem(index)"
                />

              </b-col>
            </b-row>

            <div class="d-flex mb-2 mt-4 align-items-center  justify-content-between">
              <h5> {{ $t('Account to Credit') }} </h5>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="ml-4"
                @click="repeatAccountToCredit"
              >
                <feather-icon
                  icon="PlusIcon"
                  class="mr-25"
                />
                <span> {{ $t('Add New') }} </span>
              </b-button>
            </div>

            <b-row
              v-for="(item, index) in accountToCreditFormData"
              :id="item.id"
              :key="item.id"
              ref="accounCreditRef"
            >
              <b-col md="3">
                <SelectField
                  id="gl-to-credit"
                  v-model="item.glToCredit"
                  :reduce="option => option"
                  :label="$t('GL to Credit')"
                  :placeholder="$t('Select')"
                  :options="glAccountOptions"
                  :error-name="$t('GL to Credit')"
                  rules="required"
                  item="label"
                  :loading="isLoadingGlAccount"
                  @input="setGLToCreditAmount(item.glToCredit, index)"
                />
              </b-col>

              <b-col md="3">
                <InputField
                  id="account-number"
                  v-model="item.accountNumber"
                  :label="$t('Account Number')"
                  type="text"
                  readonly
                />
              </b-col>

              <b-col md="2">
                <SelectField
                  id="entry-code-credit"
                  v-model="item.entryCode"
                  :reduce="option => option"
                  :label="$t('Sort Code')"
                  :placeholder="$t('Select')"
                  :options="creditEntryCodeOptions"
                  :error-name="$t('Sort Code')"
                  rules="required"
                  item="label"
                />
                <h6
                  class="cursor-pointer text-secondary entry-code"
                  @click="showModal('modal-primary')"
                >
                  {{ $t('Sort code meaning') }}
                  <feather-icon
                    v-b-tooltip.hover.bottom="$t('Get Information on Sort Code meaning')"
                    icon="InfoIcon"
                    class="mr-25 cursor-pointer text-danger"
                  />
                </h6>
              </b-col>

              <b-col md="3">
                <SelectField
                  id="gl-to-credit"
                  v-model="item.branchCode"
                  :reduce="option => option.value"
                  :label="$t('Branch')"
                  :placeholder="$t('Select')"
                  :options="branchOptions"
                  rules="required"
                  :error-name="$t('Branch to Credit')"
                  item="label"
                  :loading="isLoadingBranches"
                />
              </b-col>

              <b-col md="3">
                <InputNumberField
                  id="amount"
                  v-model="item.amount"
                  :label="$t('Amount')"
                  placeholder=""
                  :error-name="$t('Amount')"
                  rules="required|positive"
                />
              </b-col>

              <b-col md="3">
                <InputField
                  id="instrument-no"
                  v-model="item.instrumentNumber"
                  :label="$t('Instrument Number')"
                  placeholder=""
                  type="text"
                  rules="required"
                  :error-name="$t('Instrument Number')"
                />
              </b-col>

              <b-col md="5">
                <InputField
                  id="naration"
                  v-model="item.narration"
                  :label="$t('Narration')"
                  placeholder=""
                  type="text"
                  rules="required"
                  error-name="naration"
                />
              </b-col>

              <b-col
                md="1"
                class="mt-0"
              >
                <!-- Remove Button -->
                <feather-icon
                  v-b-tooltip.hover.bottom="$t('Remove')"
                  icon="XIcon"
                  class="mr-25 cursor-pointer text-danger"
                  @click="removeAccountToCreditItem(index)"
                />

              </b-col>
            </b-row>

            <div class="text-center mt-5">
              <Button
                :label="$t('Post')"
                :loading="isLoading"
                :disabled="isDisabled"
                size="lg"
                @click="handleSubmit"
              />
            </div>
          </validation-observer>
        </div>
      </b-col>
    </b-row>

    <!-- modal -->
    <b-modal
      id="modal-primary"
      ok-only
      :ok-title="$t('Close')"
      centered
      :title="$t('Sort Code Meaning')"
    >
      <b-card-text>
        <ul>
          <li
            v-for="(item, index) in entryCodes"
            :key="index"
          >
            <span>{{ item.name }}</span> -  <span>{{ $t(item.description) }}</span>
          </li>
        </ul>
      </b-card-text>
    </b-modal>

    <FullScreenSpinner :show="showSpinner" />
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, VBTooltip, BButton, BModal, BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightFade } from '@core/directives/animations'
import { required, positive } from '@validations'
import { ValidationObserver } from 'vee-validate'
import moment from 'moment'
import { sweetAlert } from '@core/mixins/sweetAlert'
import { mapActions, mapGetters } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { toKobo } from '@/helpers/formatAmount'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import Button from '../../../../components/button/Button.vue'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import { postingPermissions } from '../../../../../helpers/permissions'

const today = new Date()
const dateTime = moment(today).format()

export default {
  components: {
    BRow,
    BCol,
    BModal,
    InputField,
    Button,
    SelectField,
    InputNumberField,
    BCard,
    FullScreenSpinner,
    ValidationObserver,
    BButton,
    BCardText,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'height-fade': heightFade,
  },
  mixins: [sweetAlert, modalMixins],
  data() {
    return {
      isLoading: false,
      isLoadingBranches: false,
      isLoadingGlAccount: false,
      isDisabled: false,
      showFormErrorAlert: false,
      showCustomerInfo: false,
      customerList: [],
      required,
      positive,
      showSpinner: false,
      showBackButton: false,
      sortDesc: false,
      currentPage: 1,
      selected: [],
      perPage: 10,
      glAccountOptions: [],
      entryCodes: [
        { name: 'CHQW', description: 'Cheque Withdrawal' },
        { name: 'CHQC', description: 'Cheque Clearing' },
        { name: 'CHQD', description: 'Cheque deposit' },
        { name: 'CSHD', description: 'Cash deposit' },
        { name: 'CSHW', description: 'Cash Withdrawal' },
        { name: 'JRNL', description: 'Journal Posting' },
        { name: 'BCSH', description: 'Buy Cash' },
        { name: 'SCSH', description: 'Sell Cash' },
        { name: 'IBRH', description: 'Inter-branch' },
        { name: 'LTRF', description: 'Local Transfer' },
        { name: 'CLOS', description: 'Account Closure' },
        { name: 'FAAQ', description: 'Fixed Asset Acquisition' },
        { name: 'FADP', description: 'Fixed Asset Depreciation' },
        { name: 'FACT', description: 'Value Added Tax Deduction' },
        { name: 'FAAD', description: 'Fixed Asset Accumulated Depreciation @ Liquidation' },
        { name: 'FALQ', description: 'Fixed Asset Liquidation' },
        { name: 'VATD', description: 'Value Added Tax Deduction' },
      ],
      debitEntryCode: 'D-JRNL',
      creditEntryCode: 'C-JRNL',
      debitEntryCodeOptions: ['D-CSHD', 'D-CHQD1A', 'D-CHQD1B', 'D-CHQW', 'D-CSHW', 'D-JRNL', 'D-BCSH', 'D-SCSH', 'D-IBRH', 'D-LTRF'],
      creditEntryCodeOptions: ['C-CSHD', 'C-CHQD1A', 'C-CHQD1B', 'C-CHQW', 'C-CSHW', 'C-JRNL', 'C-BCSH', 'C-SCSH', 'C-IBRH', 'C-LTRF'],
      depositData: {
        accountNumber: '',
        amount: '',
        recordType: 'Debit',
        entryCode: '',
        narration: '',
        instrumentNumber: '',
        branchCode: '',
      },
      postingFormData: {
        postingData: {
          realDate: dateTime,
          postingType: 'BatchJournalPosting',
          initiatedBy: '',
        },
      },
      accountToDebitFormData: [{
        accountNumber: null,
        accountName: null,
        glToDebit: 'Select',
        amount: null,
        recordType: 'Debit',
        narration: '',
        instrumentNumber: '',
        entryCode: '',
        branchCode: '',
      }],
      accountToCreditFormData: [{
        accountNumber: null,
        accountName: null,
        glToCredit: null,
        amount: null,
        recordType: 'Credit',
        narration: '',
        instrumentNumber: '',
        entryCode: '',
        branchCode: '',
      }],
      posting: [],
    }
  },
  computed: {
    ...mapGetters({
      userDetails: 'auth/getCurrentUser',
      branchOptions: 'operations/branchOptions',
    }),
  },
  mounted() {
    this.fetchGLAccount()
  },
  methods: {
    ...mapActions({
      getAllBranches: 'operations/getAllBranches',
      getGLAccount: 'account/getAllGLAccount',
      postCashDeposit: 'posting/postingAction',
    }),
    async setGLToDebitAmount(selectedValue, index) {
      if (selectedValue.value !== 'Select') {
        await this.getAllBranches({ permission: 'BATCH_JOURNAL_POSTING' })
        this.accountToDebitFormData[index].accountNumber = selectedValue.value
        this.accountToDebitFormData[index].accountName = selectedValue.label
      }
      return selectedValue.value
    },
    async setGLToCreditAmount(selectedValue, index) {
      if (selectedValue.value !== 'Select') {
        await this.getAllBranches({ permission: 'BATCH_JOURNAL_POSTING' })
        this.accountToCreditFormData[index].accountNumber = selectedValue.value
        this.accountToCreditFormData[index].accountName = selectedValue.label
      }
      return selectedValue.value
    },

    async fetchGLAccount() {
      try {
        this.isLoadingGlAccount = true
        const response = await this.getGLAccount({ permission: 'BATCH_JOURNAL_POSTING' })
        const { data, status } = response
        if (status === 200 && data.data) {
          this.glAccountOptions = data.data.filter(item => item.status === 'Active')
            .reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }],

              // eslint-disable-next-line no-nested-ternary
              []).sort((a, b) => (a.label === b.label ? 0 : a.label < b.label ? -1 : 1))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isLoadingGlAccount = false
      }
    },
    async handleSubmit() {
      this.$refs.glPostingRules.validate().then(success => {
        if (success) {
          const accountToDebitFormData = this.accountToDebitFormData.map(item => item.amount).reduce((a, b) => a + b, 0)
          const accountToCreditFormData = this.accountToCreditFormData.map(item => item.amount).reduce((a, b) => a + b, 0)

          if (accountToDebitFormData === accountToCreditFormData) {
            this.confirm(this.glPostingAction, { text: this.$t('Are you sure you want to initiate this Batch GL?') })
          } else {
            this.alertError({ text: this.$t('Amount to Debit and Credit must be equal') })
          }
        }
      })
    },
    async glPostingAction() {
      try {
        const getAmount = this.accountToDebitFormData.map(item => item.amount)
        const formData = this.accountToDebitFormData.concat(this.accountToCreditFormData)
        const postingApprovalModel = {
          amount: getAmount ? toKobo(getAmount[0]) : '',
          initiatedBy: '',
          approvedBy: '',
          postingType: 'BatchJournalPosting',
        }
        this.postingFormData.postingApprovalModel = postingApprovalModel
        this.postingFormData.postingData.initiatedBy = this.userDetails.email
        this.postingFormData.postingEntry = formData.map(item => ({
          ...item,
          amount: toKobo(item.amount),
        }))

        this.isLoading = true
        this.isDisabled = true
        const postingData = this.postingFormData
        const response = await this.postCashDeposit({ postingData, permission: postingPermissions.BATCH_JOURNAL_POSTING })
        const { status, data } = await response
        if (status === 200 && data.isSuccessful) {
          this.resetInputField()
          const successText = this.$t('Your Batch GL request was successful. Batch GL reference ID is')
          this.alertSuccess({ text: `${successText} ${data.referenceNumber}` })
          this.$router.push({ name: 'batch-gl-list' })
        }

        if (status === 200 && !data.isSuccessful) {
          this.isLoading = false
          this.isDisabled = false
          const failedText = this.$t('Your Batch GL request failed. Reason:')
          this.alertError({ text: `${failedText} ${data.message}` })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    showEntryCodeModal() {

    },
    repeatAccountToDebit() {
      this.accountToDebitFormData.push({
        accountNumber: null,
        glToDebit: null,
        amount: null,
        recordType: 'Debit',
        narration: '',
        instrumentNumber: '',
        entryCode: '',
        branchCode: '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.accounDebitRef[0].offsetHeight)
      })
    },
    repeatAccountToCredit() {
      this.accountToCreditFormData.push({
        accountNumber: null,
        glToCredit: null,
        amount: null,
        recordType: 'Credit',
        narration: '',
        instrumentNumber: '',
        entryCode: '',
        branchCode: '',
      })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.accountCreditRef[0].offsetHeight)
      })
    },
    removeAccountToCreditItem(index) {
      this.accountToCreditFormData.splice(index, 1)
      this.trTrimHeight(this.$refs.accountCreditRef[0].offsetHeight)
    },
    removeAccountToDebitItem(index) {
      this.accountToDebitFormData.splice(index, 1)
      this.trTrimHeight(this.$refs.accounDebitRef[0].offsetHeight)
    },
    resetInputField() {
      this.accountToCreditFormData = []
      this.accountToDebitFormData = []
    },
    backNavigationAction() {
      this.$router.push({
        name: 'batch-gl-list',
      })
    },
  },
}
</script>
<style scoped>
 [dir] .demo-inline-spacing > *, .custom-control , .custom-control-inline, .custom-checkbox {
    margin-top: 0rem !important;
}
.entry-code {
  font-size: 12px;
  font-weight: 500;
  text-decoration: underline;
  font-style: italic;

}
</style>
